/* eslint-disable max-len */
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 1rem;
`;
export const Option = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  gap: 0.5rem;
`;

export const RadioBox = styled.div<{ isError?: boolean }>`
  width: 1.5rem;
  height: 1.5rem;
  border: 1px solid ${({ theme }) => theme.colors.palet.institutional10};
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
  overflow: hidden;

  &::after {
    content: '';
    width: 100%;
    height: 100%;
    display: flex;
    background: ${(props) => props.theme.colors.palet.institutional10};
    cursor: pointer;
    transform: scale(0);
    transition: 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
    -webkit-appearance: radio;
  }

  ${(props) =>
    props.isError &&
    css`
      border-color: ${props.theme.colors.palet.institutional7};
    `}
`;

export const CustomInput = styled.input`
  display: none;
  &:checked + ${RadioBox} {
    border: transparent;
    &::after {
      transform: scale(1);
    }
  }
`;

export const Error = styled.div`
  position: relative;
  background-image: url("data:image/svg+xml,%3Csvg width='22' height='19' viewBox='0 0 22 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.36333 1.9188L1.25652 15.4525C1.08903 15.7396 1.00097 16.0746 1.00001 16.4C0.999051 16.735 1.08519 17.07 1.25077 17.3572C1.41635 17.6443 1.65563 17.8931 1.94372 18.0558C2.23181 18.2281 2.55915 18.3239 2.89319 18.3239H19.1068C19.4408 18.3239 19.7682 18.2281 20.0563 18.0558C20.3444 17.8931 20.5836 17.6443 20.7492 17.3572C20.9148 17.07 21.0009 16.735 21 16.4C20.999 16.0746 20.911 15.7396 20.7435 15.4525L12.6367 1.9188C12.4663 1.64123 12.2261 1.40199 11.9389 1.23928C11.6527 1.08614 11.3292 1 11 1C10.6708 1 10.3473 1.08614 10.0611 1.23928C9.77394 1.40199 9.5337 1.64123 9.36333 1.9188Z' stroke='%23ED1651' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M11 6.83853V10.667' stroke='%23ED1651' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M11 14.4955H11.01' stroke='%23ED1651' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-size: contain;
  width: 20px;
  height: 20px;
  cursor: pointer;

  span {
    visibility: hidden;
    opacity: 0;
    transform: translateY(20px);
    transition: 300ms !important;
    position: absolute;
    white-space: nowrap;
    right: -20px;
    top: -54px;
    background: ${(props) => props.theme.colors.palet.institutional7};
    color: ${(props) => props.theme.colors.text.inverse};
    font-family: 'Unimed-Sans-SemiBold';
    font-size: 1rem;
    padding: 6px 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 4px rgba(255, 15, 100, 0.3);

    &::before {
      content: '';
      position: absolute;
      bottom: -10px;
      right: 20px;
      border: 5px solid ${(props) => props.theme.colors.palet.institutional7};
      border-right-color: transparent;
      border-bottom-color: transparent;
    }
  }

  &:hover {
    span {
      transition: 300ms;
      visibility: visible;
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
